var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenLinkInNewTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 13.4645H3.33333V4.13118H8V2.79785H3.33333C2.59333 2.79785 2 3.39785 2 4.13118V13.4645C2 14.1979 2.59333 14.7979 3.33333 14.7979H12.6667C13.4 14.7979 14 14.1979 14 13.4645V8.79785H12.6667V13.4645ZM9.33333 2.79785V4.13118H11.7267L5.17333 10.6845L6.11333 11.6245L12.6667 5.07118V7.46452H14V2.79785H9.33333Z",
    fill: "#007500"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLinkInNewTab);
export default __webpack_public_path__ + "static/media/OpenLinkInNewTab.22ef95649b5d0e71971ab595edb08348.svg";
export { ForwardRef as ReactComponent };